"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../../types/General");
const callableObjectDelete = async ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.PATH_ENTRIES]: pathEntryVar, [General_1.DEFINITION_PROP_NAMES.OBJECT]: objectEntryVar, }, processor, }) => {
    const onError = (error) => {
        if (processor.root.isInDevelopment) {
            processor.root.alert('Error object delete', error);
        }
    };
    if (!(0, ts_validators_1.valueIsRecord)(objectEntryVar)) {
        onError('The object is not valid');
        return undefined;
    }
    if (!(0, ts_validators_1.valueIsString)(pathEntryVar)) {
        onError('The path is not valid');
        return undefined;
    }
    if (pathEntryVar.includes('.')) {
        onError('The path cannot contain dots');
        return undefined;
    }
    const newObject = Object.assign({}, objectEntryVar);
    delete newObject[pathEntryVar];
    return newObject;
};
exports.default = callableObjectDelete;
